module.exports = __webpack_public_path__ + "img/soft-shadows-2.ad2c5e48.png";